import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import Grid from '@material-ui/core/Grid';
import { Doughnut } from 'react-chartjs-2';

import { ApiHelper } from '../common/helpers/ApiHelper';
import { BaseEntityPage } from '../common/components/BaseEntityPage';
import { AppStyles } from '../styles/AppTheme';
import { UiHelper } from '../common/helpers/UiHelper';
import { Helper } from '../common/helpers/Helper';
import { SearchBar } from '../common/components/SearchBar';
import { Controller } from '../common/Controller';
import { AppUiHelper } from '../helpers/AppUiHelper';
import { AppHelper } from '../helpers/AppHelper';
import { orgGroups } from '../data/data';
import { SingleSelectDropDown } from '../common/components/SingleSelectDropDown';
import { AppConfig } from '../AppConfig';
import { GraphHelper } from '../common/components/charts/GraphHelper';

const ORG_STATS_DONUT_PALETTE = [
  '#9B59B6',
  '#1E90FF',
  '#2ECC71',
  '#af5079',
  '#F59E0B',
  '#14B8A6',
  '#8B5CF6'
]

export class CustomOrgs extends BaseEntityPage {

  constructor(props) {
    super(props)
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.pageTitle = Helper.getString('orgs')
    this.pageKey = 'Orgs'
    this.defaultGroup = '_ALL'
    this.defaultStateFilterValue = 'LIVE'
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: this.pageTitle },
    ]
    this.defaultOrgParam = { method: 'GET', paths: ['miscs', 'orgsearch'], queryParams: { pb: 'fieldDef,fieldDefPaymentInfo,fieldWhitelabel', parentOrgId: 'ROOT', limit: 100, groupId: this.defaultGroup, state: this.defaultStateFilterValue } };
    this.toFetch = [this.defaultOrgParam]
    this.toFetch.push({ method: 'GET', paths: ['miscs', 'orgsearch'], queryParams: { shallow: true, state: 'LIVE', limit: AppConfig.ORG_SEARCH_LIMIT } },)
    this.toFetch.push({ method: 'GET', paths: ['items'], queryParams: { groupId: 'brandnamePRODUCT', limit: 5000 } })
    this.toFetch.push({ method: 'GET', paths: ['miscs', 'org-device-stats'] })
    this.chartOptions = GraphHelper.getdoughnutChartOptions()
    this.brandNamesById = {}

    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Info: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.title}</span>
            <br/>
            <span className={css(Styles.spanValue, Styles.line2)}>ID: {current.orgId}</span>
            <br/>
            {(current.groupId === 'SITE' || !current.groupId) && this.brandNamesById[current.brandName] &&
              <div>
                <span className={css(Styles.spanValue, Styles.line2)}>Brand Name: {this.brandNamesById[current.brandName]}</span>
                <br/>
              </div>
            }
            <span className={css(Styles.spanValue, Styles.line2)}>{current.address || '(no address)'}</span>
          </div>
        )
      },
      Type: (current) => {
        return (
          <div className={css(Styles.statesBlock)}>
            {AppUiHelper.chipLive(current.groupId)}
            {(!current.state || (current.state && current.state.toLowerCase() === 'live'))
              ? AppUiHelper.chipGreen('LIVE')
              : AppUiHelper.chipDisabled(current.state)}
          </div>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {}
    this.noTableHead = true
    if (!Controller.get().userMgr().isProductSU()) {
      this.noAdd = true
    }
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onStatusChange(e) {
    const value = e.target.value
    this.setState({
      filterState: value
    })
  }

  _renderStatusFilter() {
    return (
      <SingleSelectDropDown
        onSinglePickerFilter={this.onStatusChange.bind(this)}
        singleSelectPicker={{
          options: [
            { key: 'LIVE', value: 'LIVE' },
            { key: 'ARCHIVED', value: 'ARCHIVED' },
            { key: '_ALL', value: 'ALL' }
          ],
          defaultValue: this.state.filterState
        }}
      />
    );
  }

  renderAboveTable() {
    return (
      <div className={css(Styles.rootHolder)}>
        <Grid className={css(Styles.chartsContainer)} container spacing={2}>
          {this.buildStatsCharts().map((chart, index) => (
            <Grid item key={'org-device-stats-' + index} className={css(Styles.eachChartHolder)} xs={12} md={4}>
              <div className={css(Styles.chartOuterWrap)}>
                <div className={css(Styles.chartBlock)}>
                  <div className={css(Styles.chartTitle)}>{chart.chartTitle}</div>
                  <Doughnut
                    className={css(Styles.chartCanvas)}
                    data={chart.data}
                    options={this.chartOptions}
                    width={100}
                    height={100}
                  />
                </div>
              </div>
            </Grid>
          ))}
        </Grid>
        <div className={css(Styles.filterContainers)}>
          {this._renderStatusFilter()}
          <SearchBar
            inProcessSearch={this.state.inProcessSearch || false}
            onSearch={this.onSearch.bind(this)}
            onList={this.onList.bind(this)}
            searchText={this.state.searchText}
            onSinglePickerFilter={this.onGroupFilter.bind(this)}
            singleSelectPicker={
              {
                options: orgGroups,
                defaultValue: this.state.groupFilterValue,
              }
            }>
          </SearchBar>
        </div>
      </div>
    )
  }

  buildStatsCharts() {
    const stats = this.state.orgDeviceStats || {}
    return [
      this.buildStatsChart('State', stats.deviceCountsByState),
      this.buildStatsChart('Org Type', stats.deviceCountsByGroupId)
    ].filter(Boolean)
  }

  buildStatsChart(chartTitle, counts) {
    const entries = Object.entries(counts || {})
      .filter(([, count]) => count > 0)
      .sort(([, countA], [, countB]) => countB - countA)
    if (!entries.length) return null
    return GraphHelper.generateDoughNutGraphData({
      chartTitle,
      labels: entries.map(([key, count]) => key + ' (' + count + ')'),
      data: entries.map(([, count]) => count),
      palette: ORG_STATS_DONUT_PALETTE
    })
  }

  onGroupFilter(e) {
    const selectedGroup = e.target.value
    this.setState({
      groupFilterValue:selectedGroup
    })
  }

  getQueryParams() {
    const queryParams = {}

    if (this.state.searchText) {
      queryParams.query = this.state.searchText
    }
    if (this.state.groupFilterValue) {
      queryParams.groupId = this.state.groupFilterValue
    }
    queryParams.orgId = this.orgId;
    queryParams.pb = 'fieldDef,fieldDefPaymentInfo,fieldWhitelabel';
    queryParams.limit = 100;
    queryParams.state = this.state.filterState
    this.toFetch[0] = { method: 'GET', paths: ['miscs', 'orgsearch'], queryParams }
    return queryParams
  }

  onSearch = (searchText) => {
    this.setState({
      inProcessSearch: true,
      searchText: searchText,
    }, () => {
      ApiHelper.call({
        method: 'get',
        endPoint: ApiHelper.makeUrlPath(['miscs', 'orgsearch'], this.getQueryParams())
      }, (err, result) => {
        if (err) {
          console.log('Search Error', err)
        }
        if (result) this.handleNextpage(result)
        this._changePaginationLimit()
        this.setState({
          items: result.items,
          inProcessSearch: false,
          nextPage: result.nextPage || ''
        })
      })
    })
  }

  onList = () => {
    this.toFetch[0] = { ...this.defaultOrgParam }
    this.setState({
      searchText: '',
      groupFilterValue: this.defaultGroup,
      filterState: this.defaultStateFilterValue
    }, () => {
      this.fetchItems()
    })
  }

  _changePaginationLimit() {
    if (this.toFetchNext && this.toFetchNext.queryParams && this.toFetchNext.queryParams.limit) this.toFetchNext.queryParams.limit = 100
  }

  onFetchSuccess(results, opts) {
    const { fetchNext } = opts || {}
    if (results[0]) this.handleNextpage(results[0])
    this._changePaginationLimit()
    if (fetchNext) {
      const updatedItems = this.state.items.concat(Helper.dictToArray(results[0].items))
      this.setState({
        items: updatedItems,
        nextPageState: ApiHelper.State.READY,
      })
      return
    }
    const mainFields = ['groupId', 'title', 'address', 'emails', 'phones', 'reseller', 'state', 'brandName', 'timezone']
    const fieldDef = results[0].fieldDef
    this.fieldDefPaymentInfo = results[0].fieldDefPaymentInfo
    this.fieldWhitelabel = results[0].fieldWhitelabel
    this.fieldDef = { steps: [{
      fields: fieldDef.steps[0].fields.filter(field => Helper.inArray(mainFields, field.key))
    }]}
    this.fieldDef.steps[0].fields.push({
      key: 'subPartnerOrgIds',
      type: 'check_box',
      label: 'Sub Partner Orgs',
      hint: 'Select Sub Partner Orgs',
      options: [],
      v_required: { // eslint-disable-line camelcase
        value: false,
        err: 'Select Sub Partner Orgs'
      },
      placement: 'right',
      condition: { key: 'groupId', value: 'SUPERPARTNER' },
    })
    this.fieldDefSettings = {steps: [{
      fields: fieldDef.steps[0].fields.filter(field => !Helper.inArray(mainFields, field.key))
    }]}
    this.formDefinition = this.fieldDef
    const partnerOrgs = []
    results[1] && results[1].items.forEach(org => {
      if (org.groupId === 'PARTNER') {
        partnerOrgs.push(org)
      }
    });
    this.brandNamesById = (results[2] && results[2].items || []).reduce((acc, item) => {
      if (item.title) acc[item.id] = item.title
      return acc
    }, {})
    UiHelper.populateOptions(this.fieldDef, { items: partnerOrgs }, 'subPartnerOrgIds')
    if (results[2] && results[2].items) {
      UiHelper.populateOptions(this.fieldDef, results[2], 'brandName')
    }
    this.setState({
      items: results[0].items,
      groupFilterValue: this.defaultGroup,
      filterState: this.defaultStateFilterValue,
      orgDeviceStats: results[3] || {}
    })
  }

  onAdd() {
    this.formDefinition.steps[0].fields.find(i => i.key === 'groupId').disabled = false
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['orgs']),
    });
  }

  onEdit(current) {
    const f = this.formDefinition.steps[0].fields.find(i => i.key === 'groupId')
    if(f) f.disabled = true
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['orgs', current.id]),
    });
  }

  async onEditClick(current) {
    let response
    this.customSubmit = null
    try {
      // TODO: Ideally show a progress here; which should display the error if any
      // Autoclose the progress on success
      response = await ApiHelper.callAwait({ method: 'GET', paths: ['orgs', current.id]})
    } catch (e) {
      console.error('GET ORG:error:', e)
      return
    }
    super.openModalForEdit(response)
  }

  async onSettingsClick(current) {
    let response
    try {
      // TODO: Ideally show a progress here; which should display the error if any
      // Autoclose the progress on success
      response = await ApiHelper.callAwait({ method: 'GET', paths: ['orgs', current.id]})
    } catch (e) {
      console.error('GET ORG:error:', e)
      return
    }
    this.openModalForSettingsEdit(response)
  }

  openModalForSettingsEdit(current) {
    console.log('openModalForSettingsEdit:', current);
    this.formDefinition = this.fieldDefSettings
    this.formDefinition.formType = 'edit'
    Helper.populateFormDefinitionValues(this.formDefinition, current)
    this.onEdit(current)
    this.setState({ modalOpen: true })
  }

  openModalForPaymentInfoEdit(current) {
    console.log('openModalForPaymentInfoEdit:', current);
    this.customSubmit = null
    this.formDefinition = this.fieldDefPaymentInfo
    this.formDefinition.formType = 'edit'
    Helper.populateFormDefinitionValues(this.formDefinition, current || {})
    this.onPaymentInfoEdit(current);
    this.setState({
      modalOpen: true
    })
  }

  onPaymentInfoEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['orgs', current.id]),
    });
  }

  handleCustomSubmit = async (options) => {
    const { formData, caller } = options
    const whitelabelInfo = {}
    if(formData.logoName) whitelabelInfo.logoName = formData.logoName
    ApiHelper.call(
      { method: this.state.apiMethod, endPoint: this.state.apiEndPoint, jsonBody: { whitelabelInfo } }, (err, result) => {
        if (err) {
          const errorMessage = Helper.getErrorMsg(err)
          caller.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: errorMessage,
            success: false,
            message: errorMessage,
            inProcess: false
          })
          return
        } else {
          this.setState({ modalOpen: false })
          this.fetchItems()
        }
      })
  }

  openModalForWhitelabelEdit(current) {
    console.log('openModalForWhitelabelEdit:', current);
    if (!this.fieldWhitelabel) return
    if(current.whitelabelInfo) {
      for(const key in current.whitelabelInfo) {
        current[key] = current.whitelabelInfo[key]
      }
    }
    this.formDefinition = this.fieldWhitelabel
    this.formDefinition.formType = 'edit'
    this.customSubmit = this.handleCustomSubmit.bind(this)
    Helper.populateFormDefinitionValues(this.formDefinition, current || {})
    this.onWhitelabelEdit(current);
    this.setState({
      modalOpen: true
    })
  }

  onWhitelabelEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['orgs', current.id]),
    });
  }

  onActions(current) {
    const actions = []
    actions.push(
      <Tooltip title='Edit' placement='top-start' key={current.id + 'editTT'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() => this.onEditClick(current)}>edit</i>
        </span>
      </Tooltip>
    )
    if(current.groupId === 'SUPERPARTNER') return actions
    // actions.push(
    //   <Tooltip title='Settings' placement='top-start' key={current.id + 'Settings'}>
    //     <span className={css(AppStyles.entityTableLinkIcon)}>
    //       <i className='material-icons-outlined' onClick={() => this.onSettingsClick.bind(this)(current)}>settings</i>
    //     </span>
    //   </Tooltip>
    // )
    if(!current.groupId || Helper.inArray(['SITE'], current.groupId)) {
      actions.push(
        <Link target='_blank' to={`/admin/${Controller.get().roleHelper().getPathByOrgType('SITE')}/` + current.id}
          key={current.id + '-org'}>
          <Tooltip title='Manage' placement='top-start'>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined'>arrow_outward</i>
            </span>
          </Tooltip>
        </Link>
      )
      actions.push(
        <Link target='_blank' to={`/admin/${Controller.get().roleHelper().getPathByOrgType('SITE')}/${current.id}/revenue`}
          key={current.id + '-rev'}>
          <Tooltip title='Revenue' placement='top-start'>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined'>monetization_on</i>
            </span>
          </Tooltip>
        </Link>
      )
      actions.push(
        <Tooltip title='Edit Payment Info' placement='top-start' key={current.id + 'Info'}>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined' onClick={() =>
              this.openModalForPaymentInfoEdit.bind(this)(current)
            }>badge</i>
          </span>
        </Tooltip>
      )
    } else if(Helper.inArray(['PARTNER'], current.groupId)) {
      actions.push(
        <Link target='_blank' to={`/admin/${Controller.get().roleHelper().getPathByOrgType('PARTNER')}/` + current.id}
          key={current.id + '-org'}>
          <Tooltip title='Manage' placement='top-start'>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined'>arrow_outward</i>
            </span>
          </Tooltip>
        </Link>
      )
      actions.push(
        <Link target='_blank' to={'/admin/partners/' + current.id + '/devices-activity'}
          key={current.id + '-org'}>
          <Tooltip title='Diagnostics' placement='top-start'>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined'>analytics</i>
            </span>
          </Tooltip>
        </Link>
      )
      // actions.push(
      //   <Tooltip title='Edit Whitelabel Info' placement='top-start' key={current.id + 'Info'}>
      //     <span className={css(AppStyles.entityTableLinkIcon)}>
      //       <i className='material-icons-outlined' onClick={() =>
      //         this.openModalForWhitelabelEdit.bind(this)(current)
      //       }>tune</i>
      //     </span>
      //   </Tooltip>
      // )
    // }
    } else if(Helper.inArray(['PA'], current.groupId)) {
      actions.push(
        <Link target='_blank' to={`/admin/${Controller.get().roleHelper().getPathByOrgType('PA')}/` + current.id}
          key={current.id + '-org'}>
          <Tooltip title='Manage' placement='top-start'>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined'>arrow_outward</i>
            </span>
          </Tooltip>
        </Link>
      )
      actions.push(
        <Link target='_blank' to={`/admin/${Controller.get().roleHelper().getPathByOrgType('PA')}/${current.id}/revenue`}
          key={current.id + '-rev'}>
          <Tooltip title='Revenue' placement='top-start'>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined'>monetization_on</i>
            </span>
          </Tooltip>
        </Link>
      )
      actions.push(
        <Tooltip title='Edit Payment Info' placement='top-start' key={current.id + 'Info'}>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined' onClick={() =>
              this.openModalForPaymentInfoEdit.bind(this)(current)
            }>badge</i>
          </span>
        </Tooltip>
      )
    } else if(Helper.inArray(['FA'], current.groupId)) {
      actions.push(
        <Link target='_blank' to={`/admin/${Controller.get().roleHelper().getPathByOrgType('FA')}/` + current.id}
          key={current.id + '-org'}>
          <Tooltip title='Manage' placement='top-start'>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined'>arrow_outward</i>
            </span>
          </Tooltip>
        </Link>
      )
      actions.push(
        <Link target='_blank' to={`/admin/${Controller.get().roleHelper().getPathByOrgType('FA')}/${current.id}/revenue`}
          key={current.id + '-rev'}>
          <Tooltip title='Revenue' placement='top-start'>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined'>monetization_on</i>
            </span>
          </Tooltip>
        </Link>
      )
      actions.push(
        <Tooltip title='Edit Payment Info' placement='top-start' key={current.id + 'Info'}>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined' onClick={() =>
              this.openModalForPaymentInfoEdit.bind(this)(current)
            }>badge</i>
          </span>
        </Tooltip>
      )
    } else if(Helper.inArray(['ADVERTISER'], current.groupId)) {
      actions.push(
        <Link target='_blank' to={`/admin/${Controller.get().roleHelper().getPathByOrgType('ADVERTISER')}/` + current.id}
          key={current.id + '-org'}>
          <Tooltip title='Manage' placement='top-start'>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined'>arrow_outward</i>
            </span>
          </Tooltip>
        </Link>
      )
    } else {
      // actions.push(
      //   <Link to={'/admin/orgs/' + current.id + '/venues'} key={current.id + '-org'}>
      //     <Tooltip title='Venues' placement='top-start'>
      //       <span className={css(AppStyles.entityTableLinkIcon)}>
      //         <i className='material-icons-outlined'>list</i>
      //       </span>
      //     </Tooltip>
      //   </Link>
      // )
    }
    actions.push(
      <Tooltip title='Edit Whitelabel Info' placement='top-start' key={current.id + 'Info'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() =>
            this.openModalForWhitelabelEdit.bind(this)(current)
          }>tune</i>
        </span>
      </Tooltip>
    )
    return actions
  }

}

const Styles = StyleSheet.create({
  statesBlock:{
    display: 'flex',
    flexDirection: 'column',
    gap: 5
  },
  spanValue: {
  },
  line2: {
    fontSize: 12
  },
  filterContainers:{
    display: 'flex',
    flex: '1',
    gap: 10,
    '@media (max-width: 1024px)': {
      flexDirection: 'column'
    }
  },
  rootHolder:{
    width: '100%'
  },
  eachChartHolder: {
  },
  chartsContainer: {
    marginTop: '5px 0px',
    margin: '15px -6px',
    width: '100%'
  },
  chartOuterWrap: {
    background: '#fff',
    height: 214,
    borderRadius: 16
  },
  chartBlock: {
    borderRadius: 16,
    padding: '10px 10px 10px 10px',
    height: 160
  },
  chartCanvas: {
    marginBottom: 10
  },
  chartTitle: {
    fontSize: 16,
    color: '#121212',
    padding: 4
  }
})



// WEBPACK FOOTER //
// ./src/components/CustomOrgs.js